import axios from "axios";
import React, { useState, useEffect, Component } from 'react'
export const login = (formData) =>{
    const loginAPI = process.env.REACT_APP_WP_AUTH_API;
    const promise = new Promise(async(resolve,reject)=>{
        try {
            const response = await axios.post(loginAPI, formData, 'headers: { Authorization: `Bearer` }');
            const data = response.data;
            const token = data.token;
            if (!token) {
                reject('Unable to login. Please try after some time.');
            }
            localStorage.clear();
            localStorage.setItem('user-token', token);
            localStorage.setItem('user-data', JSON.stringify(data));
            /*
            if (rememberMe) {
                localStorage.setItem('remembered-user', formData.username);
            }
                */
            resolve(true)
        } catch(e) {
            console.log(e)
            reject('Unable to login. Please try after some time.');
        }
    })
    return promise
}
